import React, { useState } from 'react';
const faqs = [{
  q: 'Come ricevo Calcio Giovanile Pronto?',
  a: 'Accesso immediato via email in meno di 5 minuti. Tutto in PDF scaricabile.'
}, {
  q: 'Funziona per tutte le categorie?',
  a: "Sì: dalla categoria U6 fino all'U14, con volumi dedicati a ogni fascia d'età."
}, {
  q: 'Posso modificarlo?',
  a: 'Sì. Ogni allenamento è progettato per essere adattato al tuo gruppo e ai tuoi obiettivi.'
}, {
  q: 'I bonus sono inclusi?',
  a: 'Sì, tutti e 5 i bonus sono inclusi senza costo aggiuntivo.'
}, {
  q: 'È adatto a un allenatore principiante?',
  a: 'Assolutamente. Apri il volume, leggi 3 minuti ed entri in campo con tutto pronto.'
}, {
  q: 'È utile anche per società sportive?',
  a: 'Sì. Molte società lo usano come standard interno per uniformare la metodologia.'
}, {
  q: 'Posso usarlo subito?',
  a: "Sì. Riceverai l'accesso immediato e potrai usarlo già al prossimo allenamento."
}, {
  q: "Quanto dura l'accesso?",
  a: "L'accesso è a vita. Paghi una volta, lo usi per sempre."
}, {
  q: "Che differenza c'è rispetto ad altri materiali?",
  a: "È l'unico sistema italiano che copre tecnica, tattica, fisica, scouting e gestione in un'unica soluzione."
}, {
  q: 'La garanzia è reale?',
  a: 'Sì. 7 giorni senza domande. 100% del tuo denaro indietro se non è quello che ti aspettavi.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16 px-4" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] text-center mb-10 tracking-tight" data-id="element-30">
          Domande <span className="text-[#16A34A]" data-id="element-31">Frequenti</span>
        </h2>

        <div className="bg-white border border-[#E5E5EA] rounded-2xl divide-y divide-[#E5E5EA] overflow-hidden shadow-sm" data-id="element-32">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-[#FAFAFA] hover:bg-white transition-colors" data-id="element-33">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-34">
                  <span className="text-[#0A0A0A] font-black text-base" data-id="element-35">
                    {faq.q}
                  </span>
                  <span className={`text-[#16A34A] text-xl font-black flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-45' : ''}`} data-id="element-36">
                    +
                  </span>
                </button>
                {isOpen && <div className="px-6 pb-5 -mt-2" data-id="element-37">
                    <p className="text-[#5A5A66] text-sm sm:text-base font-medium leading-relaxed" data-id="element-38">
                      {faq.a}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}